var render = function render(){
  var _vm$pickedApplication;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "result-block-broker-app p-relative"
  }, [_c('div', {
    staticClass: "offers-heading"
  }, [_vm._m(0), _c('div', {
    staticClass: "offers-heading__count"
  }, [_vm._v(_vm._s(_vm.successfulOffersCount) + " ponúk")])]), _c('div', {
    staticClass: "quick-offer-settings"
  }, [_vm._m(1), _c('button', {
    staticClass: "quick-setting-button",
    "class": {
      'quick-setting-button--active': _vm.isLtv90Active
    },
    attrs: {
      "type": "button",
      "disabled": _vm.quickSettingsLoading || _vm.ltv90Changes.length === 0 || _vm.hasAutomaticLtv90,
      "title": _vm.hasAutomaticLtv90 ? 'Prirážka je zapnutá automaticky podľa vypočítaného LTV.' : 'Hromadne zapnúť prirážky bánk pre LTV nad 80 %.'
    },
    on: {
      "click": _vm.toggleLtv90
    }
  }, [_c('span', {
    staticClass: "quick-setting-button__status"
  }, [_vm._v(_vm._s(_vm.isLtv90Active ? '✓' : '+'))]), _c('span', [_c('strong', [_vm._v("90 % LTV")]), _c('small', [_vm._v(_vm._s(_vm.hasAutomaticLtv90 ? 'automaticky podľa LTV' : _vm.isManualLtv90Active ? 'prirážka zapnutá' : 'vynútiť prirážku'))])])]), _c('button', {
    staticClass: "quick-setting-button",
    "class": {
      'quick-setting-button--active': _vm.usesBankAccount
    },
    attrs: {
      "type": "button",
      "disabled": _vm.quickSettingsLoading,
      "title": "Nastaví použitie účtu a hromadne upraví súvisiace zmeny sadzieb."
    },
    on: {
      "click": _vm.toggleBankAccount
    }
  }, [_c('span', {
    staticClass: "quick-setting-button__status"
  }, [_vm._v(_vm._s(_vm.usesBankAccount ? '✓' : '+'))]), _c('span', [_c('strong', [_vm._v("Účet v banke")]), _c('small', [_vm._v(_vm._s(_vm.usesBankAccount ? 'použije sa' : 'bez účtu'))])])]), _vm.quickSettingsLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e()], 1), _c('div', {
    ref: "resultNavbar",
    staticClass: "results-legend",
    "class": {
      'sticky': _vm.isSticky
    },
    attrs: {
      "id": "resultNavbar"
    }
  }, [_c('div', {
    staticClass: "break-40px"
  }), _c('div', {
    staticClass: "text-small wrap-100px flex-row-10px sort-button pointer",
    on: {
      "click": function click($event) {
        return _vm.sortOffersBy('pozicana_suma');
      }
    }
  }, [_c('span', [_vm._v(" Celkom ")]), _c('img', {
    "class": [_vm.ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary'],
    attrs: {
      "alt": "",
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
    }
  })]), _c('fixation-choose-handler', {
    attrs: {
      "rules": ['priority'],
      "title": 'Fixácia'
    }
  }), _c('div', {
    staticClass: "text-small wrap-50px flex-row-10px sort-button pointer",
    on: {
      "click": function click($event) {
        return _vm.sortOffersBy('sadzba');
      }
    }
  }, [_c('span', [_vm._v(" Sadzba ")]), _c('img', {
    "class": [_vm.ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary'],
    attrs: {
      "alt": "",
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
    }
  })]), _c('div', {
    staticClass: "text-small wrap-100px flex-row-10px sort-button pointer",
    on: {
      "click": function click($event) {
        return _vm.sortOffersBy('mesacna_splatka');
      }
    }
  }, [_c('span', [_vm._v(" Splátka ")]), _c('img', {
    "class": [_vm.ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary'],
    attrs: {
      "alt": "",
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
    }
  })]), _c('div', {
    staticClass: "text-small wrap-50px flex-row-10px sort-button pointer",
    on: {
      "click": function click($event) {
        return _vm.sortOffersBy('splatnost_r');
      }
    }
  }, [_c('span', [_vm._v(" Splatnosť ")]), _c('img', {
    "class": [_vm.ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary'],
    attrs: {
      "alt": "",
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
    }
  })]), _c('div', {
    staticClass: "text-small wrap-50px flex-row-10px sort-button pointer",
    on: {
      "click": function click($event) {
        return _vm.sortOffersBy('popl_sprac_hypo');
      }
    }
  }, [_c('span', [_vm._v(" Poplatok ")]), _c('img', {
    "class": [_vm.ascending ? 'rotate-up display-sort filter-primary' : 'rotate-down display-sort filter-primary'],
    attrs: {
      "alt": "",
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg"
    }
  })])], 1), ((_vm$pickedApplication = _vm.pickedApplications) === null || _vm$pickedApplication === void 0 ? void 0 : _vm$pickedApplication.length) !== 0 ? _c('div', [_vm._l(_vm.pickedApplications, function (application, applicationIndex) {
    return application.stage !== 'zrusena' ? _c('mortgage-application-item-picked', {
      key: applicationIndex,
      attrs: {
        "application": application,
        "pre-picked": true
      }
    }) : _vm._e();
  }), _c('hr')], 2) : _vm._e(), _vm.loading ? _c('div', {
    staticClass: "limits-loader"
  }, [_c('span', {
    staticClass: "blc-color MGright20px"
  }, [_vm._v("prepočítavame možné ponuky financovania")]), _c('v-progress-circular', {
    staticClass: "loading-spinner small transparent",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._l(_vm.mortgageOffersData, function (offer) {
    return _c('mortgage-application-choice-item', {
      key: offer.bankKey,
      attrs: {
        "offer": offer,
        "bank-key": offer.extra.bank_code_name
      }
    });
  }), _vm.showEmptyOffersState ? _c('div', {
    staticClass: "offers-empty-state",
    "class": {
      'offers-empty-state--error': _vm.hasOffersError
    },
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "offers-empty-state__icon"
  }, [_vm._v(_vm._s(_vm.hasOffersError ? '×' : '!'))]), _c('div', {
    staticClass: "offers-empty-state__content"
  }, [_vm.hasOffersError ? _c('span', {
    staticClass: "offers-empty-state__eyebrow"
  }, [_vm._v("Technická chyba výpočtu")]) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.emptyOffersTitle))]), _c('p', [_vm._v(_vm._s(_vm.emptyOffersMessage))]), _vm.limitReasons.length ? _c('ul', _vm._l(_vm.limitReasons, function (reason) {
    return _c('li', {
      key: reason
    }, [_vm._v(_vm._s(reason))]);
  }), 0) : _vm._e(), _vm.hasOffersError ? _c('button', {
    staticClass: "offers-empty-state__retry",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.retryOffers
    }
  }, [_vm._v(" Prepočítať ponuky znova ")]) : _vm._e()])]) : _vm._e()], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "offers-heading__title"
  }, [_vm._v("Výsledky bánk")]), _c('div', {
    staticClass: "offers-heading__description"
  }, [_vm._v("Porovnanie dostupných ponúk podľa zadaného financovania.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "quick-offer-settings__intro"
  }, [_c('strong', [_vm._v("Rýchle nastavenia ponúk")]), _c('span', [_vm._v("Uplatnia sa naraz vo všetkých bankách, ktoré danú úpravu podporujú.")])]);

}]

export { render, staticRenderFns }